import styled from "styled-components";
export const GoldenWarrantySelectorContainer = styled.section`
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
  overflow: hidden;
  padding: 32px;
  margin-bottom: 32px;
  .item {
    background-color: #dce5e5;
    margin: 4px 0;
    padding: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 3px;
    cursor: pointer;
    .title-area {
      display: flex;
      align-items: center;
      .color {
        margin-left: 16px;
        width: 32px;
        height: 32px;
        border-radius: 42px;
        box-shadow: 0 0 5px rgb(0 0 0 / 20%);
        display: inline-block;
        border: solid 1px;
      }
    }
    &:hover {
      background-color: #221C35;
      color: #fff;
    }
  }
  .selected {
    background-color: #221C35;
    color: #fff;
  }
  @media only screen and (max-width: 760px) {
    padding: 16px 8px;
  }
  .notice {
    color:rgb(202, 106, 68);
    margin-top:8px;
  }
`;
